import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Search } from 'lucide-react';

const SearchableSelect = ({ options, value, onChange, placeholder = "Select Name" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedMember = options.find(opt => opt.id === value);

  const filteredOptions = options.filter(opt =>
    (opt.name || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="searchable-select-container" ref={dropdownRef} style={{ position: 'relative' }}>
      {/* Selected Box Header */}
      <div 
        className="custom-select-trigger" 
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 14px',
          background: '#f8f8f2',
          border: '1px solid #8cc63f',
          borderRadius: '20px',
          cursor: 'pointer'
        }}
      >
        <span>{selectedMember ? selectedMember.name : placeholder}</span>
        <ChevronDown size={20} color="black" strokeWidth={2} />
      </div>

      {/* Options Menu & Search Bar */}
      {isOpen && (
        <div 
          className="searchable-select-menu"
          style={{
            position: 'absolute',
            top: '105%',
            left: 0,
            right: 0,
            background: '#f8f8f2',
            border: '1px solid #8cc63f',
            borderRadius: '20px',
            zIndex: 50,
            maxHeight: '220px',
            overflowY: 'auto',
            padding: '8px'
          }}
        >
          {/* Search Input Box */}
          <div style={{ display: 'flex', alignItems: 'center', background: '#f8f8f2', border: '1px solid #8cc63f', padding: '6px 10px', borderRadius: '20px', marginBottom: '8px' }}>
            <Search size={16} color="#94a3b8" style={{ marginRight: '8px' }} />
            <input 
              type="text" 
              placeholder="Search member name..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                background: 'transparent',
                border: 'none',
                color: 'black',
                outline: 'none',
                width: '100%',
                fontSize: '0.875rem'
              }}
            />
          </div>

          {/* Member Options List */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map(member => (
              <div
                key={member.id}
                onClick={() => {
                  onChange(member.id);
                  setIsOpen(false);
                  setSearchTerm('');
                }}
                style={{
                  padding: '8px 12px',
                  color: member.id === value ? '#f8f8f2' : '#0f172a',
                  borderRadius: '20px',
                  cursor: 'pointer',
                  backgroundColor: member.id === value ? '#8cc63f' : 'transparent'
                }}
              >
                {member.name}
              </div>
            ))
          ) : (
            <div style={{ padding: '8px', color: '#94a3b8', fontSize: '0.85rem', textAlign: 'center' }}>
              No active proposers found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;